import BaseModel from "../BaseModel";
import Contact from "./Contact";

export default class Subscription extends BaseModel{
	static entity = 'subscriptions';
	static fields(){
		return {
			id: this.attr(null),
			contact_id: this.attr(null),
			email_type_id: this.attr(null),
			contact: this.belongsTo(Contact, 'contact_id'),
			user_id: this.attr(null),
			deleted_at: this.attr(null),
		}
	}
	static ignoredLogFields(){
		return ['created_at', 'updated_at', 'contact']
	}
	static route(){
		return '/email/subscriptions'
	}
}